export const headCountToSqft = (headCount: number) => Math.round(headCount * 120);
export const sqftToHeadCount = (sqft: number) => Math.max(1, Math.round(sqft / 120));
